import React from "react";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";

import {
  StyledConnectionLogo,
  StyledConnectionName,
  StyledConnectionStatus, StyledConnectionStatusWrapper,
  StyledConnectionWrapper
} from "./styledConnection";

const Connection = ({ name, nickname = '', enablePayment, enablePayout }) => {

  return (
    <StyledConnectionWrapper className="connection">
      {enablePayment !== undefined || enablePayout !== undefined ?
        <StyledConnectionStatusWrapper className="connection__status">
          <div className="connection__status-item">
            Payment
            <StyledConnectionStatus enable={enablePayment}>
              {enablePayment ? "ON" : "OFF"}
            </StyledConnectionStatus>
          </div>
          <div className="connection__status-item">
            Payout
            <StyledConnectionStatus enable={enablePayout}>
              {enablePayout ? "ON" : "OFF"}
            </StyledConnectionStatus>
          </div>
        </StyledConnectionStatusWrapper> : null}
      <StyledConnectionLogo
        icon={name}
        className="connection__tag"
      />
      <StyledConnectionName className="connection__name">
        {getServiceNameWithNickname(name, nickname)}
      </StyledConnectionName>
    </StyledConnectionWrapper>
  );
};

export default Connection;